import { api, providesList } from ".";
import qs from "query-string";
import { Question } from "models";

const url = "/questions";

const questionAPI = api.injectEndpoints({
	endpoints: (build) => ({
		getQuestions: build.query<Question[], Record<string, any> | undefined>({
			query: (query) => {
				if (query) {
					return `${url}?${qs.stringify(query)}`;
				}
				return url;
			},
			providesTags: (result) => providesList(result, "questions"),
		}),
		createQuestions: build.mutation<void, Record<string, any>>({
			query: (data) => {
				return {
					url,
					method: "POST",
					body: data,
				};
			},
			invalidatesTags: (result, error, { id }) => {
				return error ? [] : [{ type: "questions", id }];
			},
		}),
		deleteQuestions: build.mutation<void, number | undefined>({
			query: (id) => {
				return {
					url: `${url}`,
					method: "DELETE",
				};
			},
			invalidatesTags: (result, error) => {
				return error ? [] : [{ type: "questions", id: "LIST" }];
			},
		}),
	}),
});
export const { useLazyGetQuestionsQuery, useGetQuestionsQuery, useCreateQuestionsMutation, useDeleteQuestionsMutation } = questionAPI;
